import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setIsMobile } from '../features/navigation/navigationSlice';
import Navigation from '../components/Navigation';
import MobileNavigation from '../components/MobileNavigation';

const MainLayout = ({ children }) => {
  const dispatch = useDispatch();
  const { isMobile } = useSelector((state) => state.navigation);

  useEffect(() => {
    const handleResize = () => {
      dispatch(setIsMobile(window.innerWidth < 768));
    };

    // Initial check
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [dispatch]);

  return (
    <div className="min-h-screen flex flex-col">
      {isMobile ? <MobileNavigation /> : <Navigation />}
      <main 
        className={`
          flex-1 w-full max-w-[2000px] mx-auto px-4 md:px-8
          transition-all duration-300 ease-in-out
          ${isMobile ? 'pb-20' : 'pb-8'}
        `}
      >
        <div className="animate-fade-in">
          {children}
        </div>
      </main>
    </div>
  );
};

export default MainLayout; 